

















import {Vue, Component, Watch} from 'vue-property-decorator';
import {Mixins} from 'vue-property-decorator';
import SingleAndMultiDashboardPage from '@/components/Views/Dashboard/SingleAndMultiDashboardPage.vue';
import {nil} from '@/common';
import VendorBox from '@/components/Views/Vendor/VendorBox.vue';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
@Component({
    components: {
        VendorBox,
    },
})
export default class SubmitReview extends Mixins(SingleAndMultiDashboardPage, GlobalAlertMixin) {
    public feathersModel = this.$FeathersVuex.Booking;
    public routeParameter = 'booking';
    public redirectOnMulti = true;
    public vendor: any = {};
    public title = '';
    public body = '';
    public addTitle = '';
    public rating = 0;
    public readonly = false;
    public loading = false;
    public mounted() {

    }
    @Watch('itemBeingViewed')
    public onViewingItemChanged(value: any, oldValue: any) {
        if (!nil(value.reviewModel)) {
            const {rating, title, body} = value.reviewModel;
            this.readonly = true;
            this.rating = rating;
            this.body = body;
            this.title = title;
        } else {
            this.rating = Number(this.$route.query.rating) || 3;
        }
        this.vendor = value.assignedVendorModel;
        this.addTitle = `How was your ${value.purchasableModel.tierModel.name} ${value.purchasableModel.name}?`;
    }
    public get creatableReview() {
        return {
            body: this.body,
            title: this.title,
            rating: this.rating,
            purchaser: this.itemBeingViewed.purchaser,
        };
    }
    public async onSave() {
        this.loading = true;
        const {Review, Vendor} = this.$FeathersVuex;
        const rv = new Review(this.creatableReview);
        const review = await rv.create();
        this.itemBeingViewed.review = review._id;
        await this.itemBeingViewed.save();
        const relatedVendor = await Vendor.get(this.itemBeingViewed.assignedVendor);
        if (nil(relatedVendor.reviews, true)) {
            relatedVendor.reviews = [review._id];
        } else {
            relatedVendor.reviews.push(review._id);
        }
        await relatedVendor.save();
        this.showAlert('Thank You For Your Review!', 'success');
        this.refreshItem();
        this.loading = false;
    }

}
